import type { ThemeOptions } from '@mui/material/styles';

// @mui
import { CssBaseline } from '@mui/material';
import {
  createTheme,
  ThemeProvider as MUIThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import { useMemo } from 'react';

// components
import { useSettingsContext } from '../components/settings';
import customShadows from './customShadows';
import GlobalStyles from './globalStyles';
import componentsOverride from './overrides';
//
import palette from './palette';
import shadows from './shadows';
import typography from './typography';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

// TODO: Move this from legacy to src/theme
const ThemeProvider = ({ children }: Props) => {
  const { themeDirection, themeMode } = useSettingsContext();

  const themeOptions: ThemeOptions = useMemo(
    () => ({
      customShadows: customShadows(themeMode),
      direction: themeDirection,
      palette: palette(themeMode),
      shadows: shadows(themeMode),
      shape: { borderRadius: 8 },
      typography,
    }),
    [themeDirection, themeMode]
  );

  const theme = createTheme(themeOptions);

  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
};

export default ThemeProvider;
